import React from "react";
import { useSelector } from "react-redux";
import { showType } from "../../../../utils/textUtils";
import { typeInfo } from "../../../../constants/typeInfo";
import { getContentHeight } from "../../../../utils/textUtils";

const SectionSelector = ({
  sectionList,
  selectedSection,
  setSelectedSection,
  handleBefore,
  handleNext,
  isPreview = false,
  isReview = false,
}) => {
  const { assignment } = useSelector((state) => state.assignment);
  const { mode } = useSelector((state) => state.ui);

  const isMobile = mode === "mobile";

  const handleClick = (section) => {
    setSelectedSection(section);
  };

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        height: getContentHeight(isMobile),
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingTop: isMobile ? "10px" : "30px",
          fontSize: isMobile ? "14px" : "24px",
        }}
      >
        학습할 섹션을 선택해주세요.
      </div>
      <div
        style={{
          textAlign: "center",
          paddingTop: assignment?.type != "vocabulary" && "5px",
          paddingBottom:
            assignment?.type != "vocabulary" && (isMobile ? "10px" : "30px"),
          fontSize: isMobile ? "12px" : "18px",
          color: "#FF4444",
        }}
      >
        전체 섹션을 다 학습하셔야 학습완료 처리됩니다. 학습 마감일까지 미완성시
        알림톡이 발송됩니다.
      </div>
      {assignment?.type == "vocabulary" && (
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: isMobile ? "10px" : "30px",
            fontSize: isMobile ? "12px" : "18px",
            color: "#FF4444",
          }}
        >
          단어장, 매칭게임은 지속적인 학습을 위해, 진행해도 완료 처리되지
          않습니다.
        </div>
      )}
      <div
        style={{
          flex: "1", // 남은 공간을 차지
          overflowY: "auto", // 스크롤 활성화
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? "10px" : "20px",
          }}
        >
          {sectionList.length > 0 &&
            sectionList
              .slice()
              .sort((a, b) => {
                return a.id - b.id;
              })
              .map((section) => (
                <div
                  key={section.id}
                  style={{
                    display: "flex",
                    width: "70%",
                    margin: "0 auto",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isMobile ? "10px" : "20px",
                    fontSize: isMobile ? "12px" : "16px",
                    border:
                      "1px solid " +
                      (selectedSection?.id === section.id
                        ? typeInfo[assignment.type]?.color
                        : "#EBEBEB"),
                    borderRadius: "5px",
                    backgroundColor:
                      !isReview && !isPreview && section.is_finished
                        ? "#EBEBEB"
                        : selectedSection?.id === section.id &&
                          typeInfo[assignment.type]?.backgroundColor,
                    cursor:
                      !isReview && !isPreview && section.is_finished
                        ? "not-allowed"
                        : "pointer",
                    fontWeight: "bold",
                    color: "#737373",
                  }}
                  onClick={() => handleClick(section)}
                >
                  {section.type_name === ""
                    ? showType(assignment.type, section.type)
                    : section.type_name}
                </div>
              ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          padding: isMobile ? "0px" : "20px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "5px",
            padding: "5px 50px",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "18px",
            margin: isMobile ? "10px" : "20px",
          }}
          onClick={() => handleBefore()}
        >
          이전
        </button>
        <button
          style={{
            backgroundColor: "#438CFB",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "5px",
            padding: "5px 35px",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "18px",
            margin: isMobile ? "10px" : "20px",
          }}
          onClick={() => handleNext()}
        >
          {isReview ? "다시 보기" : "학습하기"}
        </button>
      </div>
    </div>
  );
};

export default SectionSelector;
